import React from 'react';

export default function ErrorModal({ onClose, title, message }) {
  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">{title}</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <p>{message}</p>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button className="orange-button button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
}